import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const bgUrl = "/a320.jpg";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [mensagem, setMensagem] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  const res = await fetch('/api/login', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
    const data = await res.json();
    if (res.ok && data.token) {
      localStorage.setItem("token", data.token);
      setMensagem("");
      navigate("/");
    } else {
      setMensagem(data.message || "Usuário ou senha inválidos");
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
  background: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.7)), url(${bgUrl}) center/cover no-repeat`,
    }}>
      <div style={{
        background: "rgba(255,255,255,0.95)",
        borderRadius: "16px",
        boxShadow: "0 4px 24px #0004",
        padding: "2.5em 2em",
        minWidth: "320px",
        maxWidth: "350px",
        textAlign: "center"
      }}>
        <h2 style={{marginBottom: "1.5em", fontWeight: 700, fontSize: "2em", color: "#007bff"}}>Air Simulado</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Usuário"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={{
              width: "100%",
              padding: "0.8em",
              marginBottom: "1em",
              borderRadius: "8px",
              border: "1px solid #ccc",
              fontSize: "1em"
            }}
            autoFocus
          />
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "0.8em",
              marginBottom: "1.5em",
              borderRadius: "8px",
              border: "1px solid #ccc",
              fontSize: "1em"
            }}
          />
          <button type="submit" style={{
            width: "100%",
            padding: "0.9em",
            background: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "1.1em",
            fontWeight: 600,
            cursor: "pointer"
          }}>Entrar</button>
        </form>
        {mensagem && <p style={{color: "#dc3545", marginTop: "1em", fontWeight: 500}}>{mensagem}</p>}
      </div>
    </div>
  );
}

export default Login;
